



































    import AbpBase from "../../../lib/abpbase";
    import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
    import {GetDicComps,GetDicComsByParientId,SaveDicCom} from '../../../api/systemBasic'
    import model from './model.vue'
    import bfz from './bfz.vue'

    @Component({
        components:{model, bfz}
    })
    export default class  extends AbpBase{
        QueryString = ''
        list:any = []
        detailList:any = []
        detailList2:any = []
        table:any = {
            loading:false,
            detailLoading:false
        }
        modelShow = false
        modelData:any = {}
        detailInfo:any = {}
        //表格高度
        get tableHeight(){
            return window.innerHeight-200
        }
        created(){
            this.getData()
        }
        async getData(){
            this.table.loading = true
            let res = await GetDicComps({QueryString:this.QueryString})
            this.list  = res.objects
            this.table.loading = false
            //默认选择第一条
            this.list[0]._highlight = true;
            this.detailInfo = this.list[0]
            this.getDetail(this.list[0].id)
        }
        async getDetail(id:any){
            let res = await GetDicComsByParientId({parientid:id})
            this.detailList = res.objects.filter((item:any)=>{return item.type==2})
            this.detailList2 = res.objects.filter((item:any)=>{return item.type==3})
        }
         //tab选择
        tabChange(currentRow:any,oldCurrentRow:any){
            if(currentRow){
                this.detailInfo = currentRow
                this.getDetail(currentRow.id)
            }
        }
        add(type:any){
            this.modelData.title = '新增'
            this.modelData.info = this.detailInfo
            this.modelData.info.type=type
            this.modelData.row = {}
            this.modelShow = true
        }
	    bfzData:any = {}
	    bfzShow = false
	    addBfz(){
        	this.bfzData = {
        		mode: 'add'
	        }
	        this.bfzShow = true
	    }
        async remove(row:any){
            row.status = !row.status
            let res = await SaveDicCom(row)
            if(res.status == 1){
                this.getDetail(this.detailInfo.id)
            }
        }
        edit(row:any){
            this.modelData.title = '编辑'
            this.modelData.info = this.detailInfo
            this.modelData.row = row
            this.modelShow = true
        }
        column = [
            {
                title:'名称',
                key:'title'
            },
	        {
		        title:'并发症类型',
		        key:'catagroy',
		        render:(h:any,p:any)=>{
			        return h('span', p.row.catagroy === 1 ? '治疗并发症' : p.row.catagroy === 2 ? '通路并发症' : '')
		        }
	        },
        ]
        detailColumn = [
            {
                title:'标题',
                key:'title',
            },
            {
                title:'排序',
                key:'orderNo',
            },
            {
                title:'并发症类型',
                key:'catagroy',
	            render:(h:any,p:any)=>{
                	return h('span', p.row.catagroy === 1 ? '治疗并发症' : p.row.catagroy === 2 ? '通路并发症' : '')
	            }
            },
            {
                title:'操作',
                width:160,
                render :(h:any,params:any) => {
                    return h('div',[
                        h('Button',{
                            props: {
                                type: 'primary',
                                size: 'small'
                            },
                            style:{
                                marginRight:'15px'
                            },
                            on: {
                                click: () => {
                                    this.edit(params.row)
                                }
                            }
                        },'编辑'),
                        h('Button',{
                            props: {
                                type: params.row.status?'error':'primary',
                                size: 'small'
                            },
                            on: {
                                click: () => {
                                    this.remove(params.row)
                                }
                            }
                        },params.row.status?'禁用':'启用')
                    ])
                },
            }
        ]
    }



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/tempManage/dicComps/index.vue